import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import './styles.scss';
import {FormattedMessage} from "react-intl";

@inject('videoChatStore')
@observer
class VideoNetworkStatus extends Component {

    render() {
        const {videoChatStore} = this.props;
        return (
            <div className={`network-status ${videoChatStore.showNetworkWarning ? '' : 'hide'}`} data-testid={'network-status'}>
                <div className="network-status-box">
                    <div className="network-status-text">
                        <FormattedMessage id={'video.chat.network.status'}/>
                    </div>
                </div>
            </div>
        );

    }
}

export default VideoNetworkStatus;
